import { APP_PAGES } from '../routes/constants';

const FLOATING_ASSISTANT_HIDDEN_ROUTES = [
  APP_PAGES.ASSISTANT,
  APP_PAGES.ONBOARDING_BASE,
  APP_PAGES.LOGIN,
  APP_PAGES.SIGNUP,
  APP_PAGES.FLOW_NEW,
  APP_PAGES.FLOW_EDITOR_NEW,
  APP_PAGES.FLOW_GROUP_NEW,
];

export function isFloatingAssistantHiddenRoute(pathname: string): boolean {
  return FLOATING_ASSISTANT_HIDDEN_ROUTES.some((route) =>
    pathname.startsWith(route),
  );
}
